/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontApplicationInputListenPodcastModel
 */
export interface FrontApplicationInputListenPodcastModel {
    /**
     * Podcast ID
     * @type {number}
     * @memberof FrontApplicationInputListenPodcastModel
     */
    programId: number;
    /**
     * Episode Uuid
     * @type {string}
     * @memberof FrontApplicationInputListenPodcastModel
     */
    episodeUuid: string;
    /**
     * Listen in seconds
     * @type {number}
     * @memberof FrontApplicationInputListenPodcastModel
     */
    listenedTimeInSeconds: number;
}

/**
 * Check if a given object implements the FrontApplicationInputListenPodcastModel interface.
 */
export function instanceOfFrontApplicationInputListenPodcastModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "programId" in value;
    isInstance = isInstance && "episodeUuid" in value;
    isInstance = isInstance && "listenedTimeInSeconds" in value;

    return isInstance;
}

export function FrontApplicationInputListenPodcastModelFromJSON(json: any): FrontApplicationInputListenPodcastModel {
    return FrontApplicationInputListenPodcastModelFromJSONTyped(json, false);
}

export function FrontApplicationInputListenPodcastModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontApplicationInputListenPodcastModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programId': json['programId'],
        'episodeUuid': json['episodeUuid'],
        'listenedTimeInSeconds': json['listenedTimeInSeconds'],
    };
}

export function FrontApplicationInputListenPodcastModelToJSON(value?: FrontApplicationInputListenPodcastModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programId': value.programId,
        'episodeUuid': value.episodeUuid,
        'listenedTimeInSeconds': value.listenedTimeInSeconds,
    };
}

